module.exports = __webpack_public_path__ + "img/visa.a5361c22.png";